<template>
	<v-card-text>
		<v-toolbar color="blue" class="white--text">
			<v-icon color="white">public</v-icon>
			<v-toolbar-title>Zainteresowania</v-toolbar-title>
			<v-spacer></v-spacer>
		</v-toolbar>
		<v-btn v-if="editable" class="mt-3 ml-3" color="primary" dark @click="readOnlyMode = !readOnlyMode">
			<v-icon class="ml-1 mr-3">{{ icon }}</v-icon>
			{{ buttonLabel }}
		</v-btn>
		<div class="ma-4 mt-5">
			<v-layout row>
				<v-flex xs2/>
				<v-flex xs7>
					<v-textarea
						browser-autocomplete="off"
						outline
						label="Zainteresowania"
						aria-label="interests"
						for="interests-profile-data-view-interests"
						id="interests-profile-data-view-interests"
						:readonly="readOnlyMode"
						v-model="data.description"
					></v-textarea>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs2/>
				<v-flex xs7>
					<v-textarea
						browser-autocomplete="off"
						outline
						aria-label="interests confirmation"
						label="Uzasadnienie zainteresowania wolontariatem zagranicznym"
						for="interests-profile-data-view-reason"
						id="interests-profile-data-view-reason"
						:readonly="readOnlyMode"
						v-model="data.confirmation"
					></v-textarea>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs2/>
				<v-flex xs7>
					<v-textarea
						browser-autocomplete="off"
						outline
						aria-label="working experience"
						label="Dotychczasowe doświadczenie w pracy wolontariackiej"
						for="interests-profile-data-view-experience"
						id="interests-profile-data-view-experience"
						:readonly="readOnlyMode"
						v-model="data.workingExperience"
					></v-textarea>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs2/>
				<v-flex xs7>
					<v-textarea
						browser-autocomplete="off"
						outline
						aria-label="extra information"
						label="Dodatkowe informacje uzupełniające"
						for="interests-profile-data-view-extra-information"
						id="interests-profile-data-view-extra-information"
						:readonly="readOnlyMode"
						v-model="data.extraInformation"
					></v-textarea>
				</v-flex>
			</v-layout>
		</div>
	</v-card-text>
</template>

<script>
	export default {
		name: "InterestsProfileDataView",

		data() {
			return {
				readOnlyMode: true,

				data: {},
			};
		},

		watch: {
			interestsData: function () {
				this.data = this.interestsData;
			},

			readOnlyMode: function (value) {
				this.$emit("edition-status", !value);
			},
		},

		computed: {
			icon() {
				return this.readOnlyMode ? "edit" : "save";
			},

			buttonLabel() {
				return this.readOnlyMode ? "Edytuj" : "Skończ edycję";
			},
		},

		props: {
			interestsData: Object,
			editable: {
				default: true,
			},
		},
	};
</script>

<style scoped>

</style>